// @core/api/endpoints/product/get_product_dependency.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductDependencyResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Get product dependency details
 * Retrieves the full configuration of a specific product dependency including type, requirement level, and validation settings.
 * @public This endpoint does not require authentication
 */
export async function GetProductDependency(
  dependency_id: string,
  options?: RequestOptions
): Promise<ProductDependencyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/dependencies/:dependency_id`;
  requestPath = requestPath.replace(':dependency_id', encodeURIComponent(dependency_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ProductDependencyResponse>(requestPath, { ...requestOptions });
}
